import React from 'react'
import { Box } from '@mui/material'
import { TempNavbar } from '../component/shared/TempNavbar'
import LoginForm from '../component/auth/LoginForm'
import { Helmet } from 'react-helmet-async'

export const LoginScreen = () => {
  return (
    <Box>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Login</title>
      </Helmet>
      <TempNavbar />
      <LoginForm />
    </Box>
  )
}
